const lookingProject = () => {
    const lookingProjectForm = document.querySelector(".looking-project-form__form");
    const body = document.querySelector("body");
    if (lookingProjectForm) {
        lookingProjectForm.addEventListener("submit", function (e){
            e.preventDefault();
            body.classList.add("loading");
            fetch(this.action, {
                method: "POST",
                body: new FormData(this)
            })
                .then(res => res.json())
                .then(res => {
                    if (res.status === 200) {
                        const submit = this.querySelector(".looking-project-form__submit");
                        submit.classList.add("disabled");
                        submit.value = "Wiadomość wysłana";
                        submit.disabled = true;
                    }
                    body.classList.remove("loading");
                })
                .catch(err => {
                    console.log(err);
                    body.classList.remove("loading");
                })
        });
    }
}
export default lookingProject;